<ng-container *ngIf="isHelpTopicsVisible">
  <ng-container *ngTemplateOutlet="helpTopics"></ng-container>
</ng-container>
<ng-container *ngTemplateOutlet="contactUs"></ng-container>
<ng-container *ngTemplateOutlet="mainFooter"></ng-container>

<ng-template #helpTopics>
  <section class="ui basic very padded fitted horizontally segment m-0">
    <div class="ui basic very padded fitted horizontally segment">
      <div class="ui container">
        <h2 class="ui fw-100 header">Help topics</h2>
        <div class="ui basic padded fitted horizontally segment">
          <div class="ui container">
            <div class="ui three column centered grid">
              <div class="sixteen-wide-mobile eight-wide-tablet column">
                <div class="ui cards">
                  <div class="ui fluid padded link card">
                    <div class="content">
                      <div class="ui basic segment">
                        <button class="ui icon primary button">
                          <i class="search icon"></i>
                        </button>
                        <h4 class="ui sub header fw-100">
                          Searching and booking
                        </h4>
                        <div class="ui link list">
                          <a href="#" class="item">Search tips </a>
                          <a href="#" class="item">Booking advertisement </a>
                          <a href="#" class="item">Booking experiences </a>
                          <a href="#" class="item">Business events </a>
                          <a href="#" class="item">Branding Campaign </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sixteen-wide-mobile eight-wide-tablet column">
                <div class="ui cards">
                  <div class="ui fluid padded link card">
                    <div class="content">
                      <div class="ui basic segment">
                        <button class="ui icon primary button">
                          <i class="search icon"></i>
                        </button>
                        <h4 class="ui sub header fw-100">
                          Searching and booking
                        </h4>
                        <div class="ui link list">
                          <a href="#" class="item">Search tips </a>
                          <a href="#" class="item">Booking advertisement </a>
                          <a href="#" class="item">Booking experiences </a>
                          <a href="#" class="item">Business events </a>
                          <a href="#" class="item">Branding Campaign </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sixteen-wide-mobile eight-wide-tablet column">
                <div class="ui cards">
                  <div class="ui fluid padded link card">
                    <div class="content">
                      <div class="ui basic segment">
                        <button class="ui icon primary button">
                          <i class="search icon"></i>
                        </button>
                        <h4 class="ui sub header fw-100">
                          Searching and booking
                        </h4>
                        <div class="ui link list">
                          <a href="#" class="item">Search tips </a>
                          <a href="#" class="item">Booking advertisement </a>
                          <a href="#" class="item">Booking experiences </a>
                          <a href="#" class="item">Business events </a>
                          <a href="#" class="item">Branding Campaign </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="ui container">
          <h2 class="ui fw-100 header">Popular help articles</h2>
          <div class="ui basic padded fitted horizontally segment">
            <div class="ui three column centered grid">
              <div class="streched row">
                <div class="sixteen-wide-mobile eight-wide-tablet column">
                  <div class="ui cards">
                    <div class="ui fluid padded link card">
                      <div class="content">
                        <div class="ui basic segment">
                          <h4 class="ui sub header fw-100">
                            How do I book a screen?
                          </h4>
                          <div class="ui link list">
                            <div class="item">
                              To book your screen you would need to “Log in”
                              first with your Google account if you are a new
                              user.
                            </div>
                          </div>
                          <a href="">
                            <span class="ui red text"> Read More </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sixteen-wide-mobile eight-wide-tablet column">
                  <div class="ui cards">
                    <div class="ui fluid padded link card">
                      <div class="content">
                        <div class="ui basic segment">
                          <h4 class="ui sub header fw-100">
                            Where do I upload my ad to be played?
                          </h4>
                          <div class="ui link list">
                            <div class="item">
                              For uploading your ad on the screen of your
                              choice, you can have 2 steps: Step 1- Go to
                              Advertisers
                            </div>
                          </div>
                          <a href="">
                            <span class="ui red text"> Read More </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sixteen-wide-mobile eight-wide-tablet column">
                  <div class="ui cards">
                    <div class="ui fluid padded link card">
                      <div class="content">
                        <div class="ui basic segment">
                          <h4 class="ui sub header fw-100">
                            How to delete an ad?
                          </h4>
                          <div class="ui link list">
                            <div class="item">
                              You need to upload your ad first. When uploaded,
                              you can see a bin option beside your uploaded ad.
                            </div>
                          </div>
                          <a href="">
                            <span class="ui red text"> Read More </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>
<ng-template #mainFooter>
  <div class="ui vertical footer secondary very padded segment">
    <div class="ui basic very padded fitted horizontally segment">
      <div class="ui container">
        <div class="ui stackable equal height stackable grid">
          <div class="four-wide column">
            <h4 class="ui header fw-100">About</h4>
            <div class="ui link list">
              <a href="how-it-works" class="item">How it works</a>
              <a href="blogs" class="item">Blogs</a>
              <a href="career" class="item">Career</a>
              <a href="about" class="item">About us </a>
            </div>
          </div>
          <div class="four-wide column">
            <h4 class="ui header fw-100">Community</h4>
            <div class="ui link list">
              <a href="signgaze-stories" class="item"> SignGaze Stories </a>
              <a href="accessibility" class="item">Accessibility</a>
              <a href="invite" class="item">Invite friends </a>
              <a href="offers" class="item">Offers</a>
            </div>
          </div>
          <div class="four-wide column">
            <h4 class="ui header fw-100">Hosts</h4>
            <div class="ui link list">
              <a href="screen-manager" class="item">Host your Screens</a>
              <a href="responsible-hosting" class="item">
                Responsible hosting
              </a>
              <a href="presence" class="item"> Our presence </a>
            </div>
          </div>
          <div class="four-wide column">
            <h4 class="ui header fw-100">Support</h4>
            <div class="ui link list">
              <a href="updates" class="item">Updates for COVID-19</a>
              <a href="help" class="item"> Help Center </a>
              <a href="cancellation" class="item">Cancellation</a>
              <a href="screen-support" class="item">Screen Support</a>
              <a href="trust" class="item">Trust & Safety </a>
            </div>
          </div>
        </div>
        <div class="ui section divider"></div>
        <div class="ui stackable text menu">
          <a class="active item"> © 2020 All rights reserved </a>
          <a class="item" href="privacy"> Privacy Policy </a>
          <a class="item" href="terms-condition"> Terms of Use </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #contactUs>
  <section
    class="ui inverted very padded fitted horizontally basic segment m-0 no radius"
  >
    <div class="ui container">
      <div class="ui one column centered grid">
        <div class="column">
          <div class="ui ui middle aligned grid">
            <div
              class="sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column"
            >
              <h3 class="ui inverted large header fw-100">
                Not finding what you need?
                <div class="sub header" style="margin-top: 8px">
                  Find category-specific content in these other sections of the
                  Help Center.
                </div>
              </h3>
            </div>
            <div class="eight-wide-computer computer-only column">
              <a
                class="ui right floated inverted white large button"
                href="contact"
              >
                Contact us
              </a>
            </div>
            <div class="sixteen-wide-mobile mobile-only column">
              <a
                class="ui left floated inverted white large button"
                href="contact"
              >
                Contact us
              </a>
            </div>
            <div class="sixteen-wide-tablet tablet-only column">
              <a
                class="ui left floated inverted white large button"
                href="contact"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>
